import { Box, Skeleton } from '@mui/material';

export const ChartSkeleton = ({
  skeletonSize,
  axisSize = '50px',
  gap = '8px',
}: {
  skeletonSize?: {
    width?: string;
    height?: string;
  };
  axisSize?: string;
  gap?: string;
}) => {
  return (
    <Box sx={{ height: '100%', ...(skeletonSize || {}) }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap,
          height: `calc(100% - calc(${axisSize} + ${gap}))`,
        }}
      >
        <Skeleton variant="rectangular" sx={{ height: '100%', width: axisSize, borderRadius: 1 }} />
        <Skeleton variant="rectangular" sx={{ height: '100%', flex: 1, borderRadius: 1 }} />
      </Box>
      <Skeleton
        variant="rectangular"
        sx={{
          height: axisSize,
          mt: gap,
          ml: 'auto',
          width: `calc(100% - calc(${axisSize} + ${gap}))`,
          borderRadius: 1,
        }}
      />
    </Box>
  );
};
